/**
 * Global Subscription Service
 *
 * Manages global subscriptions for the entire application based on user's profileId
 */

import { subscribeToGlobal } from "../layouts/dashboardLayout/pages/Users/services/subscriptionService";

let globalUnsubscribe = null;
let currentProfileId = null;

/**
 * Subscribe to global events using user's profileId
 *
 * @param {string} profileId - User's profileId from Cognito attributes (custom:profileId)
 * @param {Function} onMessage - Callback function when message is received
 * @param {Function} onError - Callback function when error occurs
 * @returns {Function} Unsubscribe function
 */
export const subscribeToUserEvents = async (profileId, onMessage, onError) => {
  if (!profileId) {
    console.warn("No profileId provided for subscription");
    return () => {};
  }

  // If already subscribed to the same profileId, don't resubscribe
  if (currentProfileId === profileId && globalUnsubscribe) {
    console.log("Already subscribed to profileId:", profileId);
    return globalUnsubscribe;
  }

  // Unsubscribe from previous subscription if exists
  if (globalUnsubscribe) {
    globalUnsubscribe();
    globalUnsubscribe = null;
  }

  try {
    console.log("Subscribing to events for profileId:", profileId);

    // Subscribe using profileId as EventId
    const unsubscribe = await subscribeToGlobal(
      profileId,
      (message) => {
        console.log("Global subscription message received:", message);
        if (onMessage) {
          onMessage(message);
        }
      },
      (err) => {
        console.error("Global subscription error:", err);
        if (onError) {
          onError(err);
        }
      }
    );

    globalUnsubscribe = unsubscribe;
    currentProfileId = profileId;

    return unsubscribe;
  } catch (error) {
    console.error("Failed to set up global subscription:", error);
    if (onError) {
      onError(error);
    }
    return () => {};
  }
};

/**
 * Unsubscribe from global events
 */
export const unsubscribeFromUserEvents = () => {
  if (globalUnsubscribe) {
    globalUnsubscribe();
    globalUnsubscribe = null;
    currentProfileId = null;
    console.log("Unsubscribed from global events");
  }
};

/**
 * Get current profileId being subscribed to
 */
export const getCurrentProfileId = () => {
  return currentProfileId;
};

const globalSubscriptionService = {
  subscribeToUserEvents,
  unsubscribeFromUserEvents,
  getCurrentProfileId,
};

export default globalSubscriptionService;
